<template>
    <div class="flex flex-col bg-gray-200 dark:bg-dark-800 mr-2 mp-2 p-2 rounded-md">
        <div class="flex items-center space-x-2 mb-2">
            <alo-icon icon="outline-paper-clip" class="h-5 w-5" />
            <div class="text-sm font-medium">
                {{ __('Anexos') }}
            </div>
        </div>

        <div class="flex flex-wrap gap-2 ">
            <AnexoShow
                v-for="anexo in anexos"
                :key="anexo.id"
                :anexo="anexo"
                :transcription="transcription"
                :mostrar-como-thumbnail="galeriaDeImagem"
                :mostrar-audio-player="mostrarAudioPlayer"
                :mostrar-video-player="mostrarVideoPlayer"
                :mostrar-remover="mostrarRemover"
                :event-id="eventId"
                @remover="$emit('remover', $event)"
            />
        </div>
    </div>
</template>

<script>
import AnexoShow from './Show'

export default {
    components: { AnexoShow },
    props: {
        anexos: Array,
        transcription: {
            type: Boolean,
            default: true,
        },
        mostrarRemover: {
            type: Boolean,
            default: false,
        },
        eventId: {
            type: String,
        },
    },
    computed: {
        /**
         * Essa lista de anexos pode ser mostrada como uma galeria de imagens?
         * Se sim, significa que todos os anexos possuem uma imagem de thumbnail.
         *
         * @return {boolean}
         */
        galeriaDeImagem() {
            return this.anexos.every((anexo) => anexo.url_thumbnail)
        },

        /**
         * Essa lista de anexos deve ser mostrada como um player de áudio?
         *
         * @return {boolean}
         */
        mostrarAudioPlayer() {
            if (this.anexos.length == 1) {
                let anexo = this.anexos[0]
                if (anexo.atributos_extras && anexo.atributos_extras.áudio) return true

                return (
                    anexo &&
                    anexo.url &&
                    (anexo.url.indexOf('.ogg') !== -1 ||
                        anexo.url.indexOf('.webm') !== -1 ||
                        anexo.url.indexOf('.oga') !== -1)
                )
            }
        },

        mostrarVideoPlayer() {
            if (this.anexos.length == 1) {
                let anexo = this.anexos[0]
                if (anexo.atributos_extras && anexo.atributos_extras.áudio) return true
                return anexo && anexo.url && (anexo.url.indexOf('.mp4') !== -1 || anexo.url.indexOf('.mkv') !== -1)
            }
        },
    },
}
</script>